angular.module('cms').config(CmsRoutes);

/* @ngInject */
function CmsRoutes($stateProvider) {
  $stateProvider
    // Public editorial pages.
    //
    // Namespaced under `/pages/` so that editorial slugs can never shadow an
    // application route — see `docs/CMS.md`.
    .state('cms-page', {
      url: '/pages/:slug',
      // `template` is an Angular state so it should be lowercase, with
      // dashes. This is the bridge towards (and from) React.
      //
      // The slug is handed over through the controller rather than
      // interpolated into this string, which would let a crafted URL inject
      // an Angular expression.
      template: '<cms-page slug="$ctrl.slug"></cms-page>',
      controller: SlugController,
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'Page',
      },
    })
    // Blog.
    .state('blog', {
      url: '/blog?page&tag',
      template: '<blog-list page="$ctrl.page" tag="$ctrl.tag"></blog-list>',
      controller: BlogListController,
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'Blog',
      },
    })
    .state('blog-post', {
      url: '/blog/:slug',
      template: '<blog-post slug="$ctrl.slug"></blog-post>',
      controller: SlugController,
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'Blog',
      },
    })
    // Two path segments, so it can never be mistaken for a post slug.
    .state('blog-category', {
      url: '/blog/category/:category?page',
      template:
        '<blog-list category="$ctrl.category" page="$ctrl.page"></blog-list>',
      controller: BlogCategoryController,
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'Blog',
      },
    })
    // FAQ. The landing page lists categories and featured questions; each
    // category has its own URL and its own JSON-LD schema (server-rendered).
    .state('faq', {
      url: '/faq',
      template: '<cms-faq></cms-faq>',
      data: {
        pageTitle: 'FAQ',
      },
    })
    .state('faq-category', {
      url: '/faq/:category',
      template: '<cms-faq category="$ctrl.category"></cms-faq>',
      controller: FaqCategoryController,
      controllerAs: '$ctrl',
      data: {
        pageTitle: 'FAQ',
      },
    })
    // Admin.
    .state('admin-cms', {
      url: '/admin/cms',
      template: '<admin-cms-pages></admin-cms-pages>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Pages',
      },
    })
    // Registered before `/admin/cms/pages/:id` so the literal `new` segment
    // is not captured as an id.
    .state('admin-cms-new', {
      url: '/admin/cms/pages/new',
      template: '<admin-cms-page-edit></admin-cms-page-edit>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - New page',
      },
    })
    .state('admin-cms-edit', {
      url: '/admin/cms/pages/:id',
      template:
        '<admin-cms-page-edit page-id="$ctrl.pageId"></admin-cms-page-edit>',
      controller: AdminCmsPageEditController,
      controllerAs: '$ctrl',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Edit page',
      },
    })
    // Blog posts share the page screens; `kind` switches labels, URLs and
    // the post-only fields.
    .state('admin-cms-posts', {
      url: '/admin/cms/posts',
      template: '<admin-cms-pages kind="\'post\'"></admin-cms-pages>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Blog posts',
      },
    })
    .state('admin-cms-post-new', {
      url: '/admin/cms/posts/new',
      template: '<admin-cms-page-edit kind="\'post\'"></admin-cms-page-edit>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - New post',
      },
    })
    .state('admin-cms-post-edit', {
      url: '/admin/cms/posts/:id',
      template:
        '<admin-cms-page-edit page-id="$ctrl.pageId" kind="\'post\'"></admin-cms-page-edit>',
      controller: AdminCmsPageEditController,
      controllerAs: '$ctrl',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Edit post',
      },
    })
    .state('admin-cms-blog-categories', {
      url: '/admin/cms/blog-categories',
      template: '<admin-cms-blog-categories></admin-cms-blog-categories>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Blog categories',
      },
    })
    .state('admin-cms-faq', {
      url: '/admin/cms/faq',
      template: '<admin-cms-faq></admin-cms-faq>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - FAQ',
      },
    })
    .state('admin-cms-trash', {
      url: '/admin/cms/trash',
      template: '<admin-cms-trash></admin-cms-trash>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Trash',
      },
    })
    .state('admin-cms-menus', {
      url: '/admin/cms/menus',
      template: '<admin-cms-menus></admin-cms-menus>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Menus',
      },
    })
    .state('admin-cms-footer-menu', {
      url: '/admin/cms/footer-menu',
      template: '<admin-cms-footer-menu></admin-cms-footer-menu>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Footer menu',
      },
    })
    .state('admin-cms-settings', {
      url: '/admin/cms/settings',
      template: '<admin-cms-settings></admin-cms-settings>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Settings',
      },
    })
    .state('admin-cms-announcements', {
      url: '/admin/cms/announcements',
      template: '<admin-cms-announcements></admin-cms-announcements>',
      requiresRole: 'admin',
      requiresAuth: true,
      footerHidden: true,
      data: {
        pageTitle: 'Admin - Announcements',
      },
    });
}

/* @ngInject */
function SlugController($stateParams) {
  this.slug = $stateParams.slug;
}

/* @ngInject */
function BlogListController($stateParams) {
  this.page = $stateParams.page;
  this.tag = $stateParams.tag;
}

/* @ngInject */
function BlogCategoryController($stateParams) {
  this.category = $stateParams.category;
  this.page = $stateParams.page;
}

/* @ngInject */
function FaqCategoryController($stateParams) {
  this.category = $stateParams.category;
}

/* @ngInject */
function AdminCmsPageEditController($stateParams) {
  this.pageId = $stateParams.id;
}
